import { postData } from '../util/Api';

/**
 * ランキングリスト内容
 * @param id 部門×ユーザーID（assignment / id）
 * @param company_id 会社ID
 * @param organisation_id 部門ID（organization / id）
 * @param organisation_name 部門名（organization / name）
 * @param user_id ユーザーID
 * @param current_totalReceived 受領済の金額（受領金額）
 * @param current_totalForecasted 予測の金額（受領されていない金額も含む）
 * @param current_rankingNumber ランキング順位（基準カラムによって変動）
 *
 * @param current_totalReceived_prevMonth 受領金額（前月）
 * @param current_totalReceived_prevYearMonth 受領金額（前年同月）
 * @param current_rankingNumber_prevMonth 前月ランキング順位（受領金額）
 * @param current_rankingNumber_prevYearMonth 前月ランキング順位（受領金額）
 */
export interface rankingListItem {
  id: number;
  company_id: number;
  organisation_id: number;
  organisation_name: string;
  user_id: number;
  current_totalReceived: number;
  current_totalForecasted: number;
  current_rankingNumber: number;
  current_totalReceived_prevMonth: number;
  current_totalReceived_prevYearMonth: number;
  current_rankingNumber_prevMonth: number;
  current_rankingNumber_prevYearMonth: number;
}

/**
 * APIレスポンス
 * @param rankingList ランキング一覧
 */
export interface rankingData {
  rankingList: rankingListItem[];
  currentPage: number;
  lastPage: number;
  total: number;
}

/**
 * APIレスポンス
 * @param
 */
export interface myRankingData {
  userId: number;
  myRank_totalReceived: number | null;
  myRank_totalForecasted: number | null;
  myRank_totalReceived_prevMonth: number | null;
  myRank_totalReceived_prevYear: number | null;
}

export class RankingModel {
  static set(data: any): rankingData {
    const d: rankingData = {
      rankingList: data.rankingList,
      currentPage: data.currentPage,
      lastPage: data.lastPage,
      total: data.total,
    };

    return d;
  }

  /**
   * ランキングデータ取得
   * @param startDate 開始日
   * @param endDate 終了日
   * @param displayColumn 表示列
   * @param isThisMonth 当月フラグ
   * @param page ページ番号
   * @returns rankingData ランキングデータ
   */
  static async get_ranking_data(params: {
    startDate: string;
    endDate: string;
    displayColumn: string;
    // isThisMonth: boolean;
    page: number;
  }): Promise<rankingData> {
    const uri = '/ranking/get_ranking_data';
    let response = await postData(uri, params);

    if (response.status !== 200) {
      window.functions.logout;
      throw new Error();
    }

    return response.data;
  }

  /**
   * 自分のランキングデータ取得
   * @returns userId ユーザーID
   * @returns myRank_totalReceived ランキング順位（受領済の金額）
   * @returns myRank_totalForecasted ランキング順位（全額）
   */
  static async get_my_ranking(): Promise<myRankingData> {
    const uri = '/ranking/get_my_ranking';
    let response = await postData(uri);

    if (response.status !== 200) {
      window.functions.logout();
      throw new Error();
    }

    return response.data;
  }
}
